import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'

export const DateFilter = ({ applyValue, item, value, label }) => {
    const [date, setDate] = useState(null)
    const { t } = useTranslation()

    useEffect(() => {
        setDate(value ? dayjs(value) : null)
    }, [value])

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                format="DD/MM/YYYY"
                label={label ?? t('Select Filter')}
                onAccept={(newDate) => {
                    const formattedDate = newDate ? newDate.format('YYYY-MM-DD') : null
                    applyValue({ ...item, value: formattedDate })
                    setDate(newDate)
                }}
                slotProps={{
                    textField: {
                        placeholder: '',
                        variant: 'filled',
                        sx: { width: '100%' },
                    },
                    actionBar: {
                        actions: ['accept', 'cancel', 'clear'],
                    },
                }}
                value={date}
                className="form-element filter-element form-element-date"
            />
        </LocalizationProvider>
    )
}